import { ComponentProps } from 'react'
import { styled, Typography } from '@mui/material'

interface IGraphy extends ComponentProps<typeof Typography> {
  as?:
    | 'default'
    | 'highlight'
    | 'lowOpacity'
    | 'white'
    | 'superlight'
    | 'error'
    | 'black'
    | 'accent'
}

const Graphy = styled(Typography)`
  &.default {
    color: #2c2c2c;
  }
  &.highlight {
    color: #142954;
  }
  &.superlight {
    color: #213fbb;
  }
  &.lowOpacity {
    color: #666766;
  }
  &.white {
    color: #f0f0f0;
  }
  &.error {
    color: red;
  }
  &.black {
    color: #2e363e;
  }
  &.accent {
    color: #2196F3;
  }
`

function CustomGraphy({ fontSize = '14px', as = 'default', ...rest }: IGraphy) {
  return (
    <Graphy fontSize={fontSize} className={as} {...rest}>
      {rest.children}
    </Graphy>
  )
}

export default CustomGraphy
